export default "__VITE_ASSET__Bjc_mVLx__"